import React, { lazy, Suspense, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Loader from "./Component/Loader";
import Error404 from "./Error404";
import { toast, ToastContainer } from "react-toastify";
import ForgotPass from "./Component/Admin/ForgotPass";
import $ from "jquery";

import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { bindActionCreators } from "@reduxjs/toolkit";
import { actionCreaters } from "./Redux";
import "react-loading-skeleton/dist/skeleton.css";
const Tracker = lazy(() => import("./Component/Tracker/Tracker"));
const LinkInfoOrder = lazy(() => import("./Component/Tracker/LinkInfoOrder"));
const Unsubscribed = lazy(() => import("./Component/Tracker/Unsubscribed"));

const Login = lazy(() => import("./Component/Admin/Login"));
// const ResetPass = lazy(() => import("./Component/Admin/ResetPass"));
const ImportSheet = lazy(() => import("./Component/Admin/ImportSheet"));
const UploadSheet = lazy(() => import("./Component/Admin/UploadSheet"));

const OrderHistoryNew = lazy(
  () => import("./Component/Admin/Order/OrderHistoryNew"),
);
const FindOrders = lazy(() => import("./Component/Admin/Order/FindOrders"));

const Products = lazy(() => import("./Component/Admin/Products"));
const EditProducts = lazy(() => import("./Component/Admin/EditProducts"));
const AddProducts = lazy(() => import("./Component/Admin/AddProducts"));
const VerifyUser = lazy(() => import("./Component/Admin//VerifyUser"));
export default function Root() {
  const { accessToken } = useSelector((state) => state.stateVals);
  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const userActions = bindActionCreators(actionCreaters, dispatch);

  useEffect(() => {
    if (location.pathname.match(/\/{2,}/)) {
      if (location.pathname.indexOf("admin") > -1) {
        window.location.href = "/admin";
      } else {
        window.location.href = "/";
      }
    }

    // eslint-disable-next-line
  }, []);
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 500) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  const backToTop = () => {
    return (
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        0,
      ),
      !1
    );
  };
  useEffect(() => {
    if (
      !location.pathname.startsWith("/verify-user/") &&
      location.pathname.includes("/admin")
    ) {
      if (accessToken) {
        const decoded = jwtDecode(accessToken);
        const currentTime = Math.floor(new Date().getTime() / 1000);
        if (currentTime > decoded.exp) {
          toast.error("Request time out!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          userActions.logOut("adminLogOut");

          navigate("/admin");
        } else if (
          location.pathname === "/admin" ||
          location.pathname === "/admin-forgotpassword"
        ) {
          navigate("/admin-view-orders");
        }
      } else {
        if (
          location.pathname !== "/admin" &&
          location.pathname !== "/admin-forgotpassword" &&
          !location.pathname.startsWith("/admin/reset-password/")
        ) {
          navigate("/admin");
        }
      }
    }
    const handleChunkError = (event) => {
      if (event.message && event.message.includes("Loading chunk")) {
        console.warn("Chunk load failed. Reloading app...");
        window.location.reload();
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    window.addEventListener("error", handleChunkError);

    // Cleanup the event listener on return
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("error", handleChunkError);
    };
  }, [location.pathname]);

  const GoOn = () => {
    window.location.href = "/admin-import-orders";
  };

  return (
    <>
      <Suspense fallback={<Loader />}>
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Tracker />} />
          <Route path="/check" element={<LinkInfoOrder />} />
          <Route path="/unsubscribe" element={<Unsubscribed />} />
          <Route path="/admin" element={<Login />} />
          <Route
            path="/verify-user/:type/:id"
            element={<VerifyUser />}
            caseSensitive={true}
          />
          {/* <Route path="/admin-forgotpassword" element={<ForgotPass />} />
          <Route
            path="/admin/reset-password/:token"
            element={<ResetPass />}
            caseSensitive={true}
          /> */}
          <Route path="/import-orders" element={<GoOn />} />
          <Route path="/admin-import-orders" element={<ImportSheet />} />
          <Route path="/admin-upload-sheet" element={<UploadSheet />} />
          <Route path="/admin-view-orders" element={<OrderHistoryNew />} />
          <Route path="/find-orders" element={<FindOrders />} />

          <Route path="/admin-products" element={<Products />} />
          <Route path="/admin-add-products" element={<AddProducts />} />
          <Route path="/admin-edit-products/:id" element={<EditProducts />} />

          <Route path="*" element={<Error404 />} />
        </Routes>
      </Suspense>
      {location.pathname.match(/\/{2,}/) ? (
        <div className="white-screen"></div>
      ) : null}
      {isVisible && (
        <button onClick={backToTop} className="to-top-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-arrow-up"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
            />
          </svg>
        </button>
      )}
    </>
  );
}
